import { AlertTriangle, CheckCircle2, Clock, XCircle } from "lucide-react";
import { cn } from "@/shared/lib/utils";

const alerts = [
  {
    id: 1,
    type: "critical",
    title: "Process deviation detected",
    description: "CFK draping temperature out of spec on Line 2",
    time: "5 min ago",
    icon: XCircle,
  },
  {
    id: 2,
    type: "warning",
    title: "Calibration due",
    description: "Torque wrench #TW-042 requires calibration",
    time: "1 hour ago",
    icon: AlertTriangle,
  },
  {
    id: 3,
    type: "pending",
    title: "Quality check pending",
    description: "Batch #2024-1201-A awaiting final inspection",
    time: "2 hours ago",
    icon: Clock,
  },
  {
    id: 4,
    type: "success",
    title: "8D report closed",
    description: "Supplier NC-2024-089 successfully resolved",
    time: "3 hours ago",
    icon: CheckCircle2,
  },
];

const typeStyles = {
  critical: "border-l-destructive bg-destructive/5",
  warning: "border-l-warning bg-warning/5",
  pending: "border-l-primary bg-primary/5",
  success: "border-l-success bg-success/5",
};

const iconStyles = {
  critical: "text-destructive",
  warning: "text-warning",
  pending: "text-primary",
  success: "text-success",
};

export function AlertsPanel() {
  return (
    <div className="bg-card rounded-xl shadow-card border border-border">
      <div className="px-5 py-4 border-b border-border">
        <h3 className="font-semibold text-foreground">Recent Alerts</h3>
        <p className="text-sm text-muted-foreground mt-0.5">Real-time quality notifications</p>
      </div>
      <div className="divide-y divide-border">
        {alerts.map((alert) => (
          <div
            key={alert.id}
            className={cn(
              "px-5 py-4 border-l-4 transition-colors hover:bg-muted/30 cursor-pointer",
              typeStyles[alert.type as keyof typeof typeStyles]
            )}
          >
            <div className="flex items-start gap-3">
              <alert.icon
                className={cn("w-5 h-5 mt-0.5 flex-shrink-0", iconStyles[alert.type as keyof typeof iconStyles])}
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">{alert.title}</p>
                <p className="text-sm text-muted-foreground mt-0.5 truncate">{alert.description}</p>
                <p className="text-xs text-muted-foreground mt-1">{alert.time}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="px-5 py-3 border-t border-border">
        <button className="text-sm text-primary font-medium hover:underline">View all alerts</button>
      </div>
    </div>
  );
}
